import {translations} from '../constants/translations';

class bbAssets {
    constructor( ) {

    }

    getAssets(company, calendarType) {
        if (!calendarType || calendarType === 'agenda') {
            return this.fetchPeopleAndResources(company);
        }

        if (company.$has('people') && (calendarType === 'person' || calendarType === 'location')) {
            return this.fetchPeople(company);
        }

        if (company.$has('resources') && calendarType === 'resource') {
            return this.fetchResources(company);
        }
    }

    fetchPeopleAndResources(company) {
        const promises = [];

        if (company.$has('people')) {
            promises.push(this.fetchPeople(company));
        }

        if (company.$has('resources')) {
            promises.push(this.fetchResources(company));
        }

        return Promise.all(promises)
            .then((assetsArray) => {
                const [people, resources] = assetsArray;
                if (people && resources) return [...people, ...resources];
                if (people) return people;
                if (resources) return resources;
                return [];
            })
            .catch(err => console.error(err));
    }

    fetchPeople(company) {
        return new Promise((resolve, reject) => {
            company.$getPeople()
                .then(people => this.mapAssets(people, translations.ASSETS.STAFF_GROUP_LABEL))
                .then(people => resolve(people))
                .catch(err => reject(err));
        });
    }

    fetchResources(company) {
        return new Promise((resolve, reject) => {
            company.$getResources()
                .then(resources => this.mapAssets(resources, translations.ASSETS.RESOURCES_GROUP_LABEL))
                .then(resources => resolve(resources))
                .catch(err => reject(err));
        });
    }

    mapAssets(assets, translationKey) {
        if (!assets.items) {
            return;
        }

        assets = assets.items;
        assets = assets
            .map((asset) => {
                asset.title = asset.name;
                asset.group = asset.group_name ? asset.group_name : translationKey;
                if (!asset.identifier) {
                    asset.identifier = asset.id;
                }
                return asset;
            })
            .sort((assetA, assetB) => {
                if (assetA.name < assetB.name) return -1;
                if (assetA.name > assetB.name) return 1;
                return 0;
            });

        return assets;
    }
}

const BBAssets = new bbAssets();

export {
    BBAssets
};
